import { io } from 'socket.io-client';
import { auth } from './firebase';
import { API_URL } from './api';

// Shared Socket.io connection for the web panels. Replaces balance polling with
// live push: the backend emits `account:updated` to `user:<uid>` when a
// reseller/agency balance changes, and the panel refetches instantly.
let socket = null;

export async function ensureSocket() {
  if (socket) return socket;
  const user = auth.currentUser;
  if (!user) return null;
  const token = await user.getIdToken();
  socket = io(API_URL, { auth: { token }, transports: ['websocket', 'polling'] });
  // Firebase ID tokens expire hourly — hand a fresh one to each reconnect so a
  // long-open panel doesn't get dropped.
  socket.io.on('reconnect_attempt', async () => {
    try {
      if (auth.currentUser) socket.auth = { token: await auth.currentUser.getIdToken() };
    } catch (_) { /* keep old token */ }
  });
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
